import styled from "styled-components";

import separatorSrc from "./separator.png";

export default styled.div`
  background: url(${separatorSrc}) bottom right no-repeat;
  background-size: auto 40px;

  flex: 1;
  display: flex;
  text-align: left;
  
  justify-content: center;
  flex-direction: column;
  padding: 0 20% 100px;

  h1 {
    position: relative;
    font-size: 4.5rem;
    padding-bottom: 10px;
    margin: 10px 0;
    color: #222;

    &::after {
      position: absolute;
      content: '';
      width: 300px;
      height: 1px;
      bottom: 0;
      left: 0;
      background-color: #ccc;
    }
  }

  h2 {
    position: relative;
    font-size: 3.7rem;
    font-weight: normal;
    padding: 0;
    margin: 0;
    color: #777;
  }
`;